import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from "src/app/shared/common/validationmethod";
import { MatSnackBar } from "@angular/material/snack-bar";
import { constants } from "src/app/shared/common/contants"
import { MatStepper } from '@angular/material/stepper';
import { ScreenCreatorTransactionService } from 'src/app/shared/services/screen-creator-transaction.service';
import { NgxUiLoaderService } from "ngx-ui-loader";
import * as moment from "moment";
import { environment } from "../../../environments/environment";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

export interface FormData {
  retrieveFieldsObject: any,
  allFields: any,
  totalObject: any,
  displayNames: any
}

export interface BooleanType {
  name: string,
  value: boolean
}

@Component({
    selector: 'app-column-types',
    templateUrl: './column-types.component.html',
    styleUrls: ['./column-types.component.scss'],
    standalone: false
})
export class ColumnTypesComponent implements OnInit {

  //ngModel
  screenCreatorData = [];

  retrieveFieldsObject = [];

  selectedFieldType = "";

  selectedFieldJson = {};

  object = Object;

  screenCreatorArray = [];

  allFields: any = [];

  customizeJsonFormat = [];

  formValidAllFieldsArray = [];

  displayNamesInFields = {};

  keysArrangementOrder = {};

  numberOfForms: number = 0;

  retrieveFieldsObjectArray = [];

  isLinear = true;

  numberOfFormsArray = [];

  formNames = [];

  listObjectDropDown: any = [];

  showNumberOfForms = false;

  totalObject: any = [];

  displayNames: any = [];

  formValid: UntypedFormGroup;

  inputNumberOfForms: number = 1;

  validation_messages;

  columnNamesGroup;

  fieldsGroup;

  showingFields = false;
  
  backgroundColorButton: any;

  @ViewChild("stepper") stepper: MatStepper;

  constructor(private dialogref: MatDialogRef<ColumnTypesComponent>, @Inject(MAT_DIALOG_DATA) public data: FormData, private errormessages: ErrorMessages, private localStorageSettings: LocalStorageSettingsService,private validation: validationmethod, private snackBar: MatSnackBar, private constant: constants, private screenCreatorTransactionService: ScreenCreatorTransactionService, private spinner: NgxUiLoaderService) {

    //messages for validations
    this.validation_messages = this.errormessages.numberOfFormsMessages;

  }

  ngOnInit() {

    this.formValidations();

    this.retrieveFieldsObject = this.data.retrieveFieldsObject;

    this.allFields = this.data.allFields;

    this.totalObject = this.data.totalObject;

    this.displayNames = this.data.displayNames;

    let commonJson = {};
    
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    //Intializing temporaryIndex equal to 0
    let temporaryIndex = 0;

    //Intializing temporaryObjectArray with empty array
    let temporaryObjectArray = [];

    for (let i = 0; i < this.retrieveFieldsObject.length; i++) {

      this.retrieveFieldsObject[i]["backgroundColorChange"] = 'white';

      //Checking selectedFieldType in retrieveFieldsObject
      if (this.retrieveFieldsObject[i].screenFieldsId == 1) {

        commonJson = this.retrieveFieldsObject[i];

      }

      temporaryIndex++;

      temporaryObjectArray.push(this.retrieveFieldsObject[i]);

      if (temporaryIndex == 2) {

        //Storing temporaryObjectArray into retrieveFieldsObjectArray, here temporaryObjectArray has two jsons
        this.retrieveFieldsObjectArray.push(temporaryObjectArray);

        //Making temporaryIndex equal to 0
        temporaryIndex = 0;

        //Clearing temporaryObjectArray
        temporaryObjectArray = [];

      }

      //When last iteration of foor loop if it has temporaryIndex equal to one
      if ((temporaryIndex == 1) && (i == this.retrieveFieldsObject.length - 1)) {

        //Storing temporaryObjectArray into retrieveFieldsObjectArray, here temporaryObjectArray has only one json
        this.retrieveFieldsObjectArray.push(temporaryObjectArray);

        //Making temporaryIndex equal to 0
        temporaryIndex = 0;

        //Clearing temporaryObjectArray
        temporaryObjectArray = [];

      }

    }

    console.log(this.retrieveFieldsObjectArray);

    //Getting the json
    this.keysArrangementOrder = JSON.parse(commonJson["keysArrangementOrder"]);

    console.log(this.keysArrangementOrder);

    //Getting the keys, this keys is in order, in this order the fields will be render
    this.screenCreatorArray = this.keysArrangementOrder["keysArrangementOrder"];

    console.log(this.screenCreatorArray);

    //Here it will generate json in this fields has related displayNameInField
    this.displayNamesInFields = JSON.parse(commonJson["displayNamesInFields"]);

    console.log(this.displayNamesInFields);

  }

  formValidations() {
    // form validations
    this.formValid = new UntypedFormGroup({
      inputNumberOfForms: new UntypedFormControl("", [Validators.min(1), Validators.max(100), Validators.pattern('^-?[0-9]\\d*(\\\\d*)?$'), Validators.required])
    });

  }

  createField() {

    if (this.selectedFieldType != "") {

      console.log(this.selectedFieldType);

    }

  }

  selectFieldType(fieldType) {

    this.showNumberOfForms = false;

    console.log(fieldType);

    //Clearing formNames
    this.formNames = [];

    //Making screenCreatorData empty
    this.screenCreatorData = [];

    this.formValidAllFieldsArray = [];

    //Storing selected field type
    this.selectedFieldType = fieldType;

    for (let i = 0; i < this.retrieveFieldsObject.length; i++) {

      //Checking selectedFieldType in retrieveFieldsObject
      if (this.retrieveFieldsObject[i].fieldType == this.selectedFieldType) {

        this.selectedFieldJson = this.retrieveFieldsObject[i];

        break;

      }

    }

    console.log(this.selectedFieldJson);

    //Outer array, for iterating changing background color of selected field and other fields color
    this.retrieveFieldsObjectArray.forEach(retrieveFieldsObjectArrayTemp => {

      //arrays inside outside array
      retrieveFieldsObjectArrayTemp.forEach(retrieveFieldsObjectArrayTemporary => {

        //Checking selectedFieldType in retrieveFieldsObject
        if (retrieveFieldsObjectArrayTemporary.fieldType == this.selectedFieldType) {

          //Changing background color of selected field
          retrieveFieldsObjectArrayTemporary.backgroundColorChange = 'cadetblue';

        }

        else {

          //Changing background color of other fields
          retrieveFieldsObjectArrayTemporary.backgroundColorChange = 'white';

        }

      });

    });

    console.log(this.retrieveFieldsObjectArray);

    //Getting numberOfForms json
    let numberOfFormsJson = this.keysArrangementOrder["numberOfForms"];

    if (this.keysArrangementOrder["iteratingWithNumber"].hasOwnProperty(fieldType)) {

      if (this.numberOfForms == 0) {

        this.numberOfForms = numberOfFormsJson[fieldType];

      }

    }

    else {

      //Getting numberOfForms number
      this.numberOfForms = numberOfFormsJson[fieldType];

    }

    console.log(this.numberOfForms);

    this.numberOfFormsArray = [];

    for (let i = 0; i < this.numberOfForms; i++) {

      this.numberOfFormsArray.push(i);

    }

    console.log(this.numberOfFormsArray);

    //Getting Form Names
    let formNamesTemporary = this.keysArrangementOrder["formNames"];

    console.log(this.formNames);

    //Checking fieldType is present in formNamesTemporary    
    if (formNamesTemporary.hasOwnProperty(fieldType)) {

      if (this.keysArrangementOrder["iteratingWithNumber"].hasOwnProperty(fieldType)) {

        let iteratingWithNumberValue = this.keysArrangementOrder["iteratingWithNumber"][fieldType];

        console.log(iteratingWithNumberValue);

        for (let i = 0; i < this.numberOfForms; i++) {

          this.formNames.push(iteratingWithNumberValue + " " + (i + 1));

        }

      }

      else {

        this.formNames = formNamesTemporary[fieldType];

      }

    }

    //Iterating showingIntegerField array
    this.keysArrangementOrder["showingIntegerField"].forEach(showingIntegerFieldTemporary => {

      //When selected fieldType is present then integer field is shown in form

      if (showingIntegerFieldTemporary == fieldType) {

        this.showNumberOfForms = true;

      }

    });

    console.log(this.showNumberOfForms);

    console.log(this.formNames);

    console.log(this.screenCreatorArray);

    this.customizeJsonFormat = [];

    console.log(this.selectedFieldJson);

    let addNewFieldsTemp = JSON.parse(this.selectedFieldJson["keysArrangementOrder"]);

    if (addNewFieldsTemp != null) {

      //Added fields into selectedFieldJson
      if (addNewFieldsTemp.hasOwnProperty("addNewFields")) {

        let addNewFieldsTemporary = addNewFieldsTemp["addNewFields"];

        //Getting the keys from addNewFields, these keys are field names
        let addNewFieldsKeys = this.object.keys(addNewFieldsTemporary);

        console.log(addNewFieldsKeys);

        addNewFieldsKeys.forEach(addNewFieldsKeysTemporary => {

          this.selectedFieldJson[addNewFieldsKeysTemporary] = addNewFieldsTemporary[addNewFieldsKeysTemporary];

        });

      }

    }

    //Iterating numberOfForms
    for (let i = 0; i < this.numberOfForms; i++) {

      let screenCreatorTemporary = [];

      //Iterate screenCreatorArray
      this.screenCreatorArray.forEach(screenCreatorArrayTemp => {

        console.log(screenCreatorArrayTemp);

        //Intializing customizeJsonFormat
        let customizeJsonFormat = {};

        customizeJsonFormat["keyName"] = screenCreatorArrayTemp;

        customizeJsonFormat["checkingDataType"] = this.selectedFieldJson[screenCreatorArrayTemp];

        customizeJsonFormat["validationMessages"] = [];

        //Pushing customizeJsonFormat
        screenCreatorTemporary.push(customizeJsonFormat);

      });

      this.screenCreatorData.push(screenCreatorTemporary);

      screenCreatorTemporary = [];

    }

    let keysArrangementOrder = JSON.parse(this.selectedFieldJson["keysArrangementOrder"]);

    console.log(keysArrangementOrder);

    if (keysArrangementOrder != null) {

      let addOtherFields = keysArrangementOrder["addOtherFields"];

      if (addOtherFields != undefined) {

        //addOtherFields is array
        for (let i = 0; i < addOtherFields.length; i++) {

          //array is present inside addOtherFields
          for (let j = 0; j < addOtherFields[i].length; j++) {

            //Getting json
            let fieldsTemporary = addOtherFields[i][j];

            //Getting fieldname from json
            let keyNames = this.object.keys(fieldsTemporary);

            let checkingRelatedDates = fieldsTemporary[keyNames[0]];

            if (checkingRelatedDates.hasOwnProperty("relatedDates")) {

              //Getting the value of relatedDates key
              let relatedDates = fieldsTemporary[keyNames[0]]["relatedDates"];

              //Getting the index of fieldname
              let indexOfKeyNames = this.screenCreatorArray.indexOf(keyNames[0]);

              //Storing the relatedDates in json
              this.screenCreatorData[i][indexOfKeyNames]["relatedDates"] = relatedDates;

            }

            if (checkingRelatedDates.hasOwnProperty("relatedDateTimes")) {

              //Getting the value of relatedDateTimes key
              let relatedDateTimes = fieldsTemporary[keyNames[0]]["relatedDateTimes"];

              //Getting the index of fieldname
              let indexOfKeyNames = this.screenCreatorArray.indexOf(keyNames[0]);

              //Storing the relatedDateTimes in json
              this.screenCreatorData[i][indexOfKeyNames]["relatedDateTimes"] = relatedDateTimes;

            }

          }

        }

      }

    }

    console.log(this.screenCreatorData);

    //Getting the value of commonFieldValidation column
    let commonFieldValidation = JSON.parse(this.selectedFieldJson["commonFieldValidation"]);

    console.log(commonFieldValidation);

    //It will generate field names
    let fieldNamesArray = this.object.keys(commonFieldValidation);

    console.log(fieldNamesArray);

    for (let i = 0; i < this.numberOfForms; i++) {

      fieldNamesArray.forEach(fieldNamesArrayTemp => {

        //It will generate fieldname related validators
        let fieldValidatorsJson = commonFieldValidation[fieldNamesArrayTemp];

        //It will generate validators names
        let fieldValidatorsNamesArray = this.object.keys(fieldValidatorsJson);

        //Iterate validators names
        fieldValidatorsNamesArray.forEach(fieldValidatorsNamesArrayTemp => {

          //It will index of field name in screenCreatorArray
          let keyNameIndex = this.screenCreatorArray.indexOf(fieldNamesArrayTemp);

          //It generate value
          this.screenCreatorData[i][keyNameIndex][fieldValidatorsNamesArrayTemp] = fieldValidatorsJson[fieldValidatorsNamesArrayTemp];

        });

      });

    }

    //Iterate screenCreatorData
    this.screenCreatorData.forEach(screenCreatorDataInner => {

      screenCreatorDataInner.forEach(screenCreatorDataTemporary => {

        //Here checking that keyName is present in displayNamesInFields
        if (this.displayNamesInFields[screenCreatorDataTemporary.keyName] != undefined) {

          //Storing displayNameInField in displayNameInField
          screenCreatorDataTemporary.displayNameInField = this.displayNamesInFields[screenCreatorDataTemporary.keyName].displayNameInField;

        }

      });

    });

    for (let i = 0; i < this.numberOfForms; i++) {

      //Calling formValiationsAllFields function
      this.formValidationsAllFields(i);

    }

    for (let i = 0; i < this.numberOfForms; i++) {

      //Iterating screenCreatorData
      this.screenCreatorData.forEach(screenCreatorDataInner => {

        screenCreatorDataInner.forEach(screenCreatorDataTemporary => {

          //It will execute Checking Which jsons has disable key
          if (screenCreatorDataTemporary.hasOwnProperty("disable")) {

            //It will make that fields has disable
            this.formValidAllFieldsArray[i].get(screenCreatorDataTemporary.keyName).disable();

          }

        });

      });

    }

    //Assigning empty array to listObjectDropDown
    this.listObjectDropDown = [];

    //Iterating numberOfForms
    for (let i = 0; i < this.numberOfForms; i++) {

      //Pushing empty array to listObjectDropDown
      this.listObjectDropDown.push([]);

    }

    //Iterating screenCreatorData
    for (let i = 0; i < 1; i++) {

      this.screenCreatorData[i].forEach(async screenCreatorDataTemporary => {

        //It will execute Checking Which jsons has disable key
        if (screenCreatorDataTemporary["checkingDataType"] == "Dropdown") {

          if (screenCreatorDataTemporary.fullExecute == true) {

            console.log(screenCreatorDataTemporary.fullExecute);

            let retrieveData: any = [];

            retrieveData = await this.screenCreatorTransactionService.retrieveCommonService(environment.dropdownUrl.concat(screenCreatorDataTemporary.httpurl));

            retrieveData.forEach(retrieveDataTemporary => {

              retrieveDataTemporary["keyJson"] = [retrieveDataTemporary[screenCreatorDataTemporary["dropdownID"]]];

              retrieveDataTemporary["dropDownValueDisplay"] = retrieveDataTemporary[screenCreatorDataTemporary["dropdownValue"]];

            });

            //Pushing retrieveData array to listObjectDropDown
            this.listObjectDropDown[i][screenCreatorDataTemporary.dropDownIndex] = retrieveData;

            console.log(this.listObjectDropDown);

            this.spinner.start();

            //Iterating screenCreatorData
            for (let j = 1; j < this.screenCreatorData.length; j++) {

              console.log(screenCreatorDataTemporary.fullExecute);

              //Pushing retrieveData array to listObjectDropDown
              this.listObjectDropDown[j][screenCreatorDataTemporary.dropDownIndex] = retrieveData;

              console.log(this.listObjectDropDown);

            }

            this.spinner.stop();

          }

        }

      });

    }

    this.columnNamesNext(this.stepper);

  }

  formValidationsAllFields(i) {

    let formGroupJsonObject = {};

    this.screenCreatorData[i].forEach(screenCreatorDataTemp => {

      //checkingDataType is Yes|No or text
      if (screenCreatorDataTemp.checkingDataType == "Yes|No" || screenCreatorDataTemp.checkingDataType == "text" || screenCreatorDataTemp.checkingDataType == "INT" || screenCreatorDataTemp.checkingDataType == "DATE" || screenCreatorDataTemp.checkingDataType == "DATETIME" || screenCreatorDataTemp.checkingDataType == "Dropdown" || screenCreatorDataTemp.checkingDataType == "TextChanging") {

        //Storing keyName in keyName
        let keyName = screenCreatorDataTemp.keyName;

        //Instantiating validators
        let validators = [];

        //validators.push(Validators.required);

        screenCreatorDataTemp.validationMessages.push({ type: 'required', message: screenCreatorDataTemp.displayNameInField + " is requried." });

        //Checking the min property is existing
        if (screenCreatorDataTemp.hasOwnProperty("min")) {

          validators.push(Validators.min(screenCreatorDataTemp.min));

          screenCreatorDataTemp.validationMessages.push({ type: 'min', message: screenCreatorDataTemp.displayNameInField + " must be greater then minimum value " + screenCreatorDataTemp.min + "." });

        }

        //Checking the max property is existing
        if (screenCreatorDataTemp.hasOwnProperty("max")) {

          validators.push(Validators.max(screenCreatorDataTemp.max));

          screenCreatorDataTemp.validationMessages.push({ type: 'max', message: screenCreatorDataTemp.displayNameInField + " is exceed maximum value " + screenCreatorDataTemp.max + "." });

        }

        //Checking the patter property is existing
        if (screenCreatorDataTemp.hasOwnProperty("pattern")) {

          validators.push(Validators.pattern(screenCreatorDataTemp.pattern));

          screenCreatorDataTemp.validationMessages.push({ type: 'pattern', message: screenCreatorDataTemp.patternMessage });

        }

        //Checking the maxlength property is existing
        if (screenCreatorDataTemp.hasOwnProperty("maxlength")) {

          validators.push(Validators.maxLength(screenCreatorDataTemp.maxlength));

          screenCreatorDataTemp.validationMessages.push({ type: 'maxlength', message: screenCreatorDataTemp.displayNameInField + " is exceed maximum length " + screenCreatorDataTemp.maxlength + "." });

        }

        //Checking the whitespace property is existing
        if (screenCreatorDataTemp.hasOwnProperty("whitespace")) {

          //validators.push(this.validation.noWhitespaceValidator);

          screenCreatorDataTemp.validationMessages.push({ type: 'whitespace', message: screenCreatorDataTemp.displayNameInField + " should not contain any white spaces." });

        }

        //Creating from control of each key name
        formGroupJsonObject[keyName] = new UntypedFormControl("", validators);

      }

    });

    let formValidAllFields: UntypedFormGroup = new UntypedFormGroup(formGroupJsonObject);

    this.formValidAllFieldsArray.push(formValidAllFields);

    console.log(this.formValidAllFieldsArray);

  }

  booleanData: BooleanType[] = [
    { name: "Yes", value: true },
    { name: "No", value: false }
  ];

  addField() {

    this.spinner.start();

    console.log(this.screenCreatorData);

    console.log(this.screenCreatorArray);

    //Adding validators to form control
    for (let i = 0; i < this.numberOfForms; i++) {

      Object.keys(this.formValidAllFieldsArray[i].controls).forEach(fieldName => {

        let fieldNameIndex = this.screenCreatorArray.indexOf(fieldName);

        let screenCreatorDataTemp = this.screenCreatorData[i][fieldNameIndex];

        //Instantiating validators
        let validators = [];

        //Checking the min property is existing
        if (screenCreatorDataTemp.hasOwnProperty("required")) {

          //Checking required value is true
          if (screenCreatorDataTemp["required"] == true) {

            validators.push(Validators.required);

          }

        }

        //Checking the min property is existing
        if (screenCreatorDataTemp.hasOwnProperty("min")) {

          validators.push(Validators.min(screenCreatorDataTemp.min));

        }

        //Checking the max property is existing
        if (screenCreatorDataTemp.hasOwnProperty("max")) {

          validators.push(Validators.max(screenCreatorDataTemp.max));

        }

        //Checking the patter property is existing
        if (screenCreatorDataTemp.hasOwnProperty("pattern")) {

          validators.push(Validators.pattern(screenCreatorDataTemp.pattern));

        }

        //Checking the maxlength property is existing
        if (screenCreatorDataTemp.hasOwnProperty("maxlength")) {

          validators.push(Validators.maxLength(screenCreatorDataTemp.maxlength));

        }

        //Checking the whitespace property is existing
        if (screenCreatorDataTemp.hasOwnProperty("whitespace")) {

          validators.push(this.validation.noWhitespaceValidator);

        }

        this.formValidAllFieldsArray[i].controls[fieldName].setValidators(validators);

        this.formValidAllFieldsArray[i].controls[fieldName].updateValueAndValidity();

      });

    }

    let isExecute = true;

    for (let i = 0; i < this.numberOfForms; i++) {

      // checking the form is valid or not while insert
      if (!this.formValidAllFieldsArray[i].valid) {

        isExecute = false;

        // displaying validation messages
        this.validation.validateAllFormFields(this.formValidAllFieldsArray[i]);

        this.validation.getvalidationmessage();

      }

    }

    if (isExecute) {

      let conditionBoolean = true;

      //Iterating screenCreatorData
      this.screenCreatorData.forEach(screenCreatorDataInner => {

        screenCreatorDataInner.forEach(screenCreatorDataTemporary => {

          //Checking the conditionFieldName is existing
          if (screenCreatorDataTemporary.hasOwnProperty("conditionFieldName")) {

            //Getting keyValue of screenCreatorDataTemporary
            let fieldValue: number = Number(screenCreatorDataTemporary["keyValue"]);

            //Getting the index of conditionFieldName
            let keyNameIndex = this.screenCreatorArray.indexOf(screenCreatorDataTemporary["conditionFieldName"]);

            //Getting the value of conditionFieldName
            let conditionFieldValue: number = Number(screenCreatorDataInner[keyNameIndex].keyValue);

            //Checking the condition fieldValue greater then or equal to condtionFieldValue
            if (fieldValue >= conditionFieldValue) {

            }

            else {

              //If the condtion generate false then conditionBoolean become false
              conditionBoolean = false;

              this.snackBar.open(screenCreatorDataTemporary.conditionMessage, "OK", { duration: 5000 });

            }

          }

          //Checking the checkingMaxlength is existing
          if (screenCreatorDataTemporary.hasOwnProperty("checkingMaxlength")) {

            //Getting keyValue of screenCreatorDataTemporary
            let fieldValue = screenCreatorDataTemporary["keyValue"];

            //Getting the index of checkingMaxlength
            let keyNameIndex = this.screenCreatorArray.indexOf(screenCreatorDataTemporary["checkingMaxlength"]);

            //Getting the value of conditionFieldName
            let checkingMaxlengthValue: number = Number(screenCreatorDataInner[keyNameIndex].keyValue);

            if (conditionBoolean) {

              //fieldValue not equal to undefined example like Radio Value 3
              if (fieldValue != undefined) {

                //Checking the condition fieldValue greater then or equal to condtionFieldValue
                if (checkingMaxlengthValue >= fieldValue.toString().trim().length) {

                }

                else {

                  //If the condtion generate false then conditionBoolean become false
                  conditionBoolean = false;

                  this.snackBar.open(screenCreatorDataTemporary.checkingMaxlengthMessage + fieldValue.toString().trim().length, "OK", { duration: 5000 });

                }

              }

            }

          }

          if (conditionBoolean) {

            //Checking the checkingValue is existing
            if (screenCreatorDataTemporary.hasOwnProperty("checkingValue")) {

              console.log(screenCreatorDataTemporary);

              //Getting keyValue of screenCreatorDataTemporary
              let fieldValue = screenCreatorDataTemporary["keyValue"];

              let filterIterationTemp = screenCreatorDataTemporary["checkingValue"];

              //Iterating filterIterationTemp example in radionValue1 object it has radioValue2 and radioValue3
              filterIterationTemp.forEach(filterIterationTemporary => {

                console.log(filterIterationTemporary);

                //Getting the index of checkingValue
                let keyNameIndex = this.screenCreatorArray.indexOf(filterIterationTemporary);

                console.log(keyNameIndex);

                //Getting the value of checkingValue example in radionValue1 object it has radioValue2 value and radioValue3 value
                let getCheckingValue = screenCreatorDataInner[keyNameIndex].keyValue;

                console.log(getCheckingValue);

                if (conditionBoolean) {

                  //getCheckingValue not equal to undefined example like Radio Value 3
                  if (getCheckingValue != undefined) {

                    //Checking the condition fieldValue greater then or equal to condtionFieldValue
                    if (fieldValue.toString().trim() != getCheckingValue.toString().trim()) {

                    }

                    else {

                      //If the condtion generate false then conditionBoolean become false
                      conditionBoolean = false;

                      this.snackBar.open(screenCreatorDataTemporary.checkingValueMessage + screenCreatorDataTemporary.displayNameInField + " and " + screenCreatorDataInner[keyNameIndex].displayNameInField, "OK", { duration: 5000 });

                    }

                  }

                }

              });

            }

          }

        });

      });

      if (conditionBoolean) {

        console.log(this.screenCreatorData);

        //Storing somve values from screenCreatorData to screenCreatorData 
        for (let i = 0; i < this.screenCreatorData.length; i++) {

          //It is iterating screenCreatorData based on index
          this.screenCreatorData[i].forEach(screenCreatorDataInnerTemporary => {

            //checking storingFieldValue present in screenCreatorDataInnerTemporary
            if (screenCreatorDataInnerTemporary.hasOwnProperty("storingFieldValue")) {

              //Example for field start & end date, it stores screen creator index 
              let screenCreatorIndexTemp = screenCreatorDataInnerTemporary["storingFieldValue"][i][0];

              //Example for field start & end date, it stores for screen creator index 0, endDateName
              let fieldNameTemp = screenCreatorDataInnerTemporary["storingFieldValue"][i][1];

              //Getting the index of fieldNameTemp
              let keyNameIndex = this.screenCreatorArray.indexOf(fieldNameTemp);

              //Getting the keyValue of screenCreatorDataInnerTemporary
              this.screenCreatorData[screenCreatorIndexTemp][keyNameIndex].keyValue = screenCreatorDataInnerTemporary.keyValue;

            }

          });

        }

        //Storing somve values from screenCreatorData to screenCreatorData 
        for (let i = this.screenCreatorData.length - 1; i > 0; i--) {

          //It is iterating screenCreatorData based on index
          this.screenCreatorData[i].forEach(screenCreatorDataInnerTemporary => {

            //checking storingFieldIterating present in screenCreatorDataInnerTemporary
            if (screenCreatorDataInnerTemporary.hasOwnProperty("storingFieldIterating")) {

              //Getting the value of storingFieldValue
              let fieldNameTemp = screenCreatorDataInnerTemporary["storingFieldIterating"];

              //Getting the index of fieldNameTemp
              let keyNameIndex = this.screenCreatorArray.indexOf(fieldNameTemp);

              //Getting the keyValue of screenCreatorDataInnerTemporary
              this.screenCreatorData[i - 1][keyNameIndex].keyValue = screenCreatorDataInnerTemporary.keyValue;

            }

          });

        }

        console.log(this.allFields);

        let allFieldNamesTemporary = [];

        //Iterating allFields, it has all fields
        this.allFields.forEach(allFieldsTemporary => {

          //Iterating allFieldsTemporary
          allFieldsTemporary.forEach(allFieldsTemporary => {

            console.log(allFieldsTemporary);

            //Checking keyName is equal to fieldName
            if (allFieldsTemporary.keyName == "fieldName") {

              //If keyName is equal to fieldName then keyValue is storing in allFieldNamesTemporary
              allFieldNamesTemporary.push(allFieldsTemporary.keyValue)

            }

          });

        });

        console.log(allFieldNamesTemporary);

        let checkingFieldName = true;

        let fieldValueTemporary = "";

        //Iterating screenCreatorData
        for (let i = 0; i < this.screenCreatorData.length; i++) {

          //It will index of field name in screenCreatorArray
          let keyNameIndex = this.screenCreatorArray.indexOf("fieldName");

          //It generate value
          fieldValueTemporary = this.screenCreatorData[i][keyNameIndex].keyValue;

          console.log(fieldValueTemporary);

          if (allFieldNamesTemporary.includes(fieldValueTemporary) != false) {

            checkingFieldName = false;

            break;

          }

          else {

            allFieldNamesTemporary.push(fieldValueTemporary);

          }

        }

        if (checkingFieldName) {

          console.log(this.screenCreatorData.length);

          if (this.screenCreatorData.length == 1) {

            //It will find index of fieldName in screenCreatorArray
            let keyNameIndex = this.screenCreatorArray.indexOf("fieldName");

            this.screenCreatorData[0][keyNameIndex]["pairedValue"] = 0;

          }

          else {

            //It will find index of fieldName in screenCreatorArray
            let keyNameIndex = this.screenCreatorArray.indexOf("fieldName");

            //Assinging zero to pairedValueTemporary
            let pairedValueTemporary = 0;

            //Iterating allFields
            for (let i = this.allFields.length - 1; i >= 0; i--) {

              //Getting the value of pairedValue
              pairedValueTemporary = this.allFields[i][keyNameIndex]["pairedValue"];

              //If pairedValueTemporary value greater then zero, the forloop will break
              if (pairedValueTemporary > 0) {

                break;

              }

            }

            console.log(pairedValueTemporary);

            //Iterating screenCreatorData array 
            this.screenCreatorData.forEach(screenCreatorDataInner => {

              //Storing fieldType value in screenCreatorDataInner keyValue at keyName fieldType
              screenCreatorDataInner[keyNameIndex]["pairedValue"] = pairedValueTemporary + 1;

            });

          }

          //Iterating screenCreatorData array 
          this.screenCreatorData.forEach(screenCreatorDataInner => {

            //It will find index of fieldType in screenCreatorArray
            let keyNameIndex = this.screenCreatorArray.indexOf("fieldType");

            //Storing fieldType value in screenCreatorDataInner keyValue at keyName fieldType
            screenCreatorDataInner[keyNameIndex].keyValue = this.selectedFieldType;

          });

          //Storing screenCreatorData array into allFields array
          this.screenCreatorData.forEach(screenCreatorDataInner => {

            let screenCreatorDataTemporary = [];

            screenCreatorDataInner.forEach(screenCreatorDataInnerTemporary => {

              let customizeJsonFormat = {};

              customizeJsonFormat["keyName"] = screenCreatorDataInnerTemporary.keyName;

              customizeJsonFormat["keyValue"] = screenCreatorDataInnerTemporary.keyValue;

              customizeJsonFormat["checkingDataType"] = screenCreatorDataInnerTemporary.checkingDataType;

              customizeJsonFormat["displayName"] = screenCreatorDataInnerTemporary.displayNameInField;

              customizeJsonFormat["pairedValue"] = screenCreatorDataInnerTemporary.pairedValue;

              //Pushing customizeJsonFormat
              screenCreatorDataTemporary.push(customizeJsonFormat);

            });

            //Getting the index of fieldname
            let keyNameIndex = this.screenCreatorArray.indexOf("fieldType");

            console.log(keyNameIndex);

            console.log(screenCreatorDataTemporary[keyNameIndex]);

            let tempKeyValue = screenCreatorDataTemporary[keyNameIndex].keyValue;

            //Checking fieldType value is Attachment.
            if (tempKeyValue == "Attachment") {

              console.log(this.screenCreatorData.length);

              //It will find index of fieldName in screenCreatorArray.
              let fieldNameIndex = this.screenCreatorArray.indexOf("fieldName");

              //Assinging zero to pairedValueTemporary.
              let pairedValueTemporary = 0;

              //Iterating allFields, for getting pariedValue.
              for (let i = this.allFields.length - 1; i >= 0; i--) {

                //Getting the value of pairedValue
                pairedValueTemporary = this.allFields[i][fieldNameIndex]["pairedValue"];

                //If pairedValueTemporary value greater then zero, the forloop will break
                if (pairedValueTemporary > 0) {

                  break;

                }

              }

              //Storing pairedValue in screenCreatorData at fieldNameIndex array in pairedValue key.
              screenCreatorDataTemporary[fieldNameIndex]["pairedValue"] = pairedValueTemporary + 1;

              console.log(screenCreatorDataTemporary[fieldNameIndex]["pairedValue"]);

              let screenCreatorDataTemp = [];

              screenCreatorDataTemporary.forEach(screenCreatorDataReference => {

                screenCreatorDataTemp.push(Object.assign({}, screenCreatorDataReference));

              });

              //Getting the index of fieldname
              let keyNameIndex = this.screenCreatorArray.indexOf("fieldName");

              console.log(keyNameIndex);

              screenCreatorDataTemp[keyNameIndex].keyValue = screenCreatorDataTemporary[keyNameIndex].keyValue + "path";

              //Getting the index of fieldname
              keyNameIndex = this.screenCreatorArray.indexOf("maxLength");

              console.log(keyNameIndex);

              screenCreatorDataTemp[keyNameIndex].keyValue = Number(screenCreatorDataTemporary[keyNameIndex].keyValue) + 250;

              //Getting the index of fieldname
              keyNameIndex = this.screenCreatorArray.indexOf("fieldType");

              console.log(keyNameIndex);

              screenCreatorDataTemp[keyNameIndex].keyValue = "Free Text Single line";

              //Getting the index of fieldname
              let keyNameIndexReference = this.screenCreatorArray.indexOf("fieldName");

              //Getting the index of fieldname
              keyNameIndex = this.screenCreatorArray.indexOf("imageName");

              console.log(keyNameIndex);

              screenCreatorDataTemp[keyNameIndex].keyValue = screenCreatorDataTemporary[keyNameIndexReference].keyValue;

              //Getting the index of fieldname
              keyNameIndex = this.screenCreatorArray.indexOf("showForm");

              console.log(keyNameIndex);

              screenCreatorDataTemp[keyNameIndex].keyValue = true;

              //Getting the index of fieldname
              keyNameIndex = this.screenCreatorArray.indexOf("showinGrid");

              console.log(keyNameIndex);

              screenCreatorDataTemp[keyNameIndex].keyValue = true;

              keyNameIndex = this.screenCreatorArray.indexOf("mandatory");

              console.log(keyNameIndex);

              screenCreatorDataTemp[keyNameIndex].keyValue = screenCreatorDataTemporary[keyNameIndex].keyValue;

              console.log(screenCreatorDataTemp);

              //Storing retrieved internal object from attachment column type like example filepath licensepath.
              let screenCreatorDataStoring = [];

              //Storing which fields needed.
              let fieldNamesTemp = ["fieldName", "maxLength", "fieldType", "imageName", "dataType", "showForm", "showinGrid", "mandatory"];

              fieldNamesTemp.forEach(fieldNamesTemporary => {

                //Getting the index of fieldNamesTemporary from the screenCreatorArray.
                keyNameIndex = this.screenCreatorArray.indexOf(fieldNamesTemporary);

                //Storing the array screenCreatorDataTemp array of json, by using keyNameIndex.
                screenCreatorDataStoring.push(screenCreatorDataTemp[keyNameIndex]);

              });

              this.allFields.push(screenCreatorDataStoring);

            }//Stop of if condition, it will execute if field type is attachment.

            this.allFields.push(screenCreatorDataTemporary);

            console.log(this.allFields);

          });

          console.log(this.allFields);

          this.reset();

          this.selectFieldType(this.selectedFieldType);

          this.fieldNamesBack(this.stepper);

        }

        else {

          this.snackBar.open(this.constant.duplicateFieldName + fieldValueTemporary + ".", "OK", { duration: 5000 });

        }

      }

    }

    this.spinner.stop();

  }

  reset() {

    for (let i = 0; i < this.numberOfForms; i++) {

      let screenCreatorDataTemporary = [];

      this.screenCreatorArray.forEach(screenCreatorArrayTemp => {

        let customizeJsonFormat = {};

        customizeJsonFormat["keyName"] = screenCreatorArrayTemp;

        customizeJsonFormat["keyValue"] = "";

        customizeJsonFormat["checkingDataType"] = this.selectedFieldJson[screenCreatorArrayTemp];

        customizeJsonFormat["validationMessages"] = [];

        customizeJsonFormat["validationMessages"].push({ type: 'required', message: screenCreatorArrayTemp + " is required." });

        //Pushing customizeJsonFormat
        screenCreatorDataTemporary.push(customizeJsonFormat);

      });

      this.screenCreatorData[i] = screenCreatorDataTemporary;

    }

    for (let i = 0; i < this.numberOfForms; i++) {

      this.formValidAllFieldsArray[i].reset();

    }

    this.numberOfForms = 0;

  }

  changeStartEndDateValue(screenCreatorDataTemp) {

    console.log(screenCreatorDataTemp);

    screenCreatorDataTemp.keyValue = moment(screenCreatorDataTemp.keyValue).format("YYYY-MM-DD");

    //Getting array
    let relatedDates = screenCreatorDataTemp["relatedDates"];

    console.log(relatedDates);

    //Iterating array
    relatedDates.forEach(relatedDatesTemporary => {

      console.log(relatedDatesTemporary);

      //Getting the index of fieldname
      let keyNameIndex = this.screenCreatorArray.indexOf(relatedDatesTemporary[1]);

      //Storing the keyValue into startDateValue or endDateValue
      this.screenCreatorData[relatedDatesTemporary[0]][keyNameIndex][relatedDatesTemporary[2]] = screenCreatorDataTemp.keyValue;

    });

    if (relatedDates.length > 1) {

      //Getting column value of keysArrangementOrder
      let keysArrangementOrder = JSON.parse(this.selectedFieldJson["keysArrangementOrder"]);

      //SettingStartDateValues will generate array
      let settingStartDateValues = keysArrangementOrder["settingStartDateValues"];

      //SettingEndDateValues will generate array
      let settingEndDateValues = keysArrangementOrder["settingEndDateValues"];

      //Storing two arrays into another array
      let startEndDatesTemporary = [settingStartDateValues, settingEndDateValues];

      //Iterating array
      startEndDatesTemporary.forEach(startEndDatesTemp => {

        //Iterating array
        startEndDatesTemp.forEach(settingTemp => {

          //Getting the index of screenCreator
          let sCDIndexGet = settingTemp[0][0];

          //Getting the index of screencreator
          let sCDIndexSet = settingTemp[1][0];

          //Getting the minValue or maxValuee index
          let mMIndexGet = this.screenCreatorArray.indexOf(settingTemp[0][1]);

          //Getting the minValue or maxValuee index
          let mMIndexSet = this.screenCreatorArray.indexOf(settingTemp[1][1]);

          //Getting the screen creator data value
          let sCDValueGet = settingTemp[0][2];

          //Getting the screen creator data value
          let sCDValueSet = settingTemp[1][2];

          //Checking the keyValue is not undefined
          if (this.screenCreatorData[sCDIndexGet][mMIndexGet][sCDValueGet] != undefined) {

            this.screenCreatorData[sCDIndexSet][mMIndexSet][sCDValueSet] = this.screenCreatorData[sCDIndexGet][mMIndexGet][sCDValueGet];

          }

          else {

            this.screenCreatorData[sCDIndexSet][mMIndexSet][sCDValueSet] = this.screenCreatorData[sCDIndexGet][mMIndexGet][sCDValueSet];

          }

        });

      });

    }

    /*//Iterating screenCreatorData array
    this.screenCreatorData[i].forEach(screenCreatorDataReference => {

      //The keyName is checking with startDateName, here keyname is startdate, for enddate endDateValue is not required, when startdate is selected
      if (screenCreatorDataReference.startDateName == screenCreatorDataTemp.keyName) {

        //KeyValue is storing in startDateValue, in enddate storing startdatevalue
        screenCreatorDataReference.startDateValue = screenCreatorDataTemp.keyValue;

        this.screenCreatorData[i].forEach(screenCreatorDataAnotherReference => {

          if (screenCreatorDataAnotherReference.keyName == screenCreatorDataReference.startDateName) {

            console.log(screenCreatorDataAnotherReference);

            screenCreatorDataAnotherReference.startDateValue = screenCreatorDataReference.keyValue;

          }

        });

      }

      //The keyName is checking with endDateName, here keyName is enddate, for startdate startDateValue is not required, when enddate is selected
      if (screenCreatorDataReference.endDateName == screenCreatorDataTemp.keyName) {

        //KeyValue is storing in endDateValue, in startdate storing enddatevalue
        screenCreatorDataReference.endDateValue = screenCreatorDataTemp.keyValue;

      }

    });*/

    console.log(this.screenCreatorData);

  }

  changeStartEndDateTimeValue(screenCreatorDataTemp) {

    console.log(screenCreatorDataTemp);

    var dateString = screenCreatorDataTemp.keyValue._d;

    var dateObj = new Date(dateString);

    console.log(dateObj);

    var momentObj = moment(dateObj);

    console.log(momentObj);

    screenCreatorDataTemp.keyValue = momentObj.format('YYYY-MM-DD HH:mm:ss');

    //Getting array
    let relatedDateTimes = screenCreatorDataTemp["relatedDateTimes"];

    console.log(relatedDateTimes);

    //Iterating array
    relatedDateTimes.forEach(relatedDatesTemporary => {

      console.log(relatedDatesTemporary);

      //Getting the index of fieldname
      let keyNameIndex = this.screenCreatorArray.indexOf(relatedDatesTemporary[1]);

      //Storing the keyValue into startDateValue or endDateValue
      this.screenCreatorData[relatedDatesTemporary[0]][keyNameIndex][relatedDatesTemporary[2]] = screenCreatorDataTemp.keyValue;

    });

    if (relatedDateTimes.length > 1) {

      //Getting column value of keysArrangementOrder
      let keysArrangementOrder = JSON.parse(this.selectedFieldJson["keysArrangementOrder"]);

      //SettingStartDateValues will generate array
      let settingStartDateTimeValues = keysArrangementOrder["settingStartDateTimeValues"];

      //SettingEndDateValues will generate array
      let settingEndDateTimeValues = keysArrangementOrder["settingEndDateTimeValues"];

      //Storing two arrays into another array
      let startEndDateTimesTemporary = [settingStartDateTimeValues, settingEndDateTimeValues];

      //Iterating array
      startEndDateTimesTemporary.forEach(startEndDateTimesTemp => {

        //Iterating array
        startEndDateTimesTemp.forEach(settingTemp => {

          //Getting the index of screenCreator
          let sCDIndexGet = settingTemp[0][0];

          //Getting the index of screencreator
          let sCDIndexSet = settingTemp[1][0];

          //Getting the minValue or maxValuee index
          let mMIndexGet = this.screenCreatorArray.indexOf(settingTemp[0][1]);

          //Getting the minValue or maxValuee index
          let mMIndexSet = this.screenCreatorArray.indexOf(settingTemp[1][1]);

          //Getting the screen creator data value
          let sCDValueGet = settingTemp[0][2];

          //Getting the screen creator data value
          let sCDValueSet = settingTemp[1][2];

          //Checking the keyValue is not undefined
          if (this.screenCreatorData[sCDIndexGet][mMIndexGet][sCDValueGet] != undefined) {

            this.screenCreatorData[sCDIndexSet][mMIndexSet][sCDValueSet] = this.screenCreatorData[sCDIndexGet][mMIndexGet][sCDValueGet];

          }

          else {

            this.screenCreatorData[sCDIndexSet][mMIndexSet][sCDValueSet] = this.screenCreatorData[sCDIndexGet][mMIndexGet][sCDValueSet];

          }

        });

      });

    }

    /*//Iterating screenCreatorData array
    this.screenCreatorData[i].forEach(screenCreatorDataReference => {

      //The keyName is checking with startDateTimeName, here keyName is startdatetime, for enddatetime endDateTimeValue is not required
      if (screenCreatorDataReference.startDateTimeName == screenCreatorDataTemp.keyName) {

        //keyValue is storing in startDateTimeValue, in enddatetime storing startdatetimevalue
        screenCreatorDataReference.startDateTimeValue = screenCreatorDataTemp.keyValue;

      }

      //The keyName is checking with endDateTimeName, here keyName is enddatetime, for startdatetime startDateTimeValue is not required
      if (screenCreatorDataReference.endDateTimeName == screenCreatorDataTemp.keyName) {

        //keyValue is storing in endDateTimeValue, in startdatetime storing enddatevalue
        screenCreatorDataReference.endDateTimeValue = screenCreatorDataTemp.keyValue;

      }

    });*/

    console.log(this.screenCreatorData);

  }

  columnNamesNext(stepper: MatStepper) {

    if (this.selectedFieldType == "") {

      this.snackBar.open(this.constant.isColumnSelected, "OK", { duration: 5000 });

      this.isLinear = false;

    }

    else {

      this.isLinear = true;

      this.showingFields = true;

      //Going to next page
      stepper.next();

    }

  }

  fieldNamesBack(stepper: MatStepper) {

    //Outer array, for iterating chaning backing color of selected field and other fields color
    this.retrieveFieldsObjectArray.forEach(retrieveFieldsObjectArrayTemp => {

      //arrays inside outside array
      retrieveFieldsObjectArrayTemp.forEach(retrieveFieldsObjectArrayTemporary => {

        //Changing background color of other fields
        retrieveFieldsObjectArrayTemporary.backgroundColorChange = 'white';

      });

    });

    this.selectedFieldType = "";

    this.numberOfForms = 0;

    this.inputNumberOfForms = 1;

    this.showingFields = false;

    //Going to previous page
    stepper.previous();

  }

  childDropDown(screenCreatorData, arrayIndex) {

    //So when screenCreatorData object has childDropDownIndex it means children relationship, so in the childdropdown store the value related to parent
    if (screenCreatorData.hasOwnProperty("childDropDownIndex") && screenCreatorData.keyValue != "" && screenCreatorData.keyValue != undefined) {

      if (screenCreatorData.hasOwnProperty("storingName")) {

        //In temporaryName storing storingName value, here example in storingName tableID is storing, tableID is primary key name of table
        let temporaryFeildName = screenCreatorData["storingName"];

        //Field value
        let temporaryFieldValue = "";

        //Iterating listObjectDropDown
        this.listObjectDropDown[arrayIndex][screenCreatorData.dropDownIndex].forEach(listObjectDropDownTemporary => {

          if (screenCreatorData.keyValue == listObjectDropDownTemporary[screenCreatorData.dropdownValue]) {

            //Generating value here example in temporaryFieldValue storing value of tableID
            temporaryFieldValue = listObjectDropDownTemporary[temporaryFeildName];

          }

        });

        //Checking storingPrimaryFieldName is present in screenCreatorData
        if (screenCreatorData.hasOwnProperty("storingPrimaryFieldName")) {

          //Iterating storingPrimaryFieldName, here example storingPrimaryFieldName array values fieldName and dropDownValues
          screenCreatorData["storingPrimaryFieldName"].forEach(screenCreatorDataTemporary => {

            //Getting the index of fieldname
            let storingPrimaryFieldNameIndex = this.screenCreatorArray.indexOf(screenCreatorDataTemporary);

            //Storing temporaryFieldValue
            this.screenCreatorData[arrayIndex][storingPrimaryFieldNameIndex].keyValue = temporaryFieldValue;

          });

        }

      }

      //It will execute the particular screenCreatorData with arrayIndex
      this.screenCreatorData[arrayIndex].forEach(async screenCreatorDataTemporary => {

        //Checking which child dropdown it is related by comparing dropDownIndex with childDropDownIndex
        if (screenCreatorDataTemporary.dropDownIndex == screenCreatorData.childDropDownIndex) {

          //If this json needs to call api service, then pathExecute is true
          if (screenCreatorDataTemporary.pathExecute == true) {

            //Clearning screenCreatorDtaTemporary keyValue
            screenCreatorDataTemporary.keyValue = "";

            //Creating retrieveData Object for storing data
            let retrieveData: any = [];

            retrieveData = await this.screenCreatorTransactionService.retrieveCommonService(environment.dropdownUrl.concat(screenCreatorDataTemporary.httpurl) + "/" + screenCreatorData.keyValue);

            retrieveData.forEach(retrieveDataTemporary => {

              retrieveDataTemporary["keyJson"] = [retrieveDataTemporary[screenCreatorDataTemporary["dropdownID"]]];

              retrieveDataTemporary["dropDownValueDisplay"] = retrieveDataTemporary[screenCreatorDataTemporary["dropdownValue"]];

            });

            //Storing the data in child drop down realted to parent
            this.listObjectDropDown[arrayIndex][screenCreatorDataTemporary.dropDownIndex] = retrieveData;

            console.log(this.listObjectDropDown);

          }

        }

      });

    }

  }

  enterNumberOfForms() {

    if (!this.formValid.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValid);

      this.validation.getvalidationmessage();

    }

    else {

      this.reset();

      this.numberOfForms = this.inputNumberOfForms;

      this.selectFieldType(this.selectedFieldType);

    }

  }

  changeOtherFieldValue(screenCreatorData, arrayIndex) {

    console.log(screenCreatorData);

    //Checking storingFieldName is present in screenCreatorData
    if (screenCreatorData.hasOwnProperty("storingFieldName")) {

      //Iterating storingFieldName, here example storingFieldName array values fieldName 
      screenCreatorData["storingFieldName"].forEach(screenCreatorDataTemporary => {

        //Getting the index of fieldname
        let storingFieldNameIndex = this.screenCreatorArray.indexOf(screenCreatorDataTemporary);

        if (screenCreatorData.keyValue != undefined) {

          //Storing temporaryFieldValue
          this.screenCreatorData[arrayIndex][storingFieldNameIndex].keyValue = screenCreatorData.keyValue + screenCreatorData["addingPrefixToTheValue"];

        }

      });

    }

  }

  close() {

    this.reset();

    console.log(this.allFields);

    let totalObject = [];

    let displayNames = [];

    this.allFields.forEach(allFieldsTemp => {

      let temporaryJson = {};

      let temporaryDisplayNames = {};

      allFieldsTemp.forEach(allFieldsTemporary => {

        if (allFieldsTemporary.keyValue != undefined) {

          console.log(typeof allFieldsTemporary.keyValue);

          //It will execute if keyValue value has datatype string.
          if (typeof allFieldsTemporary.keyValue === "string") {

            //It will execute keyValue will be empty.
            if (allFieldsTemporary.keyValue.toString().trim() == "") {

              console.log(allFieldsTemporary.keyValue);

              //Assinging undefined to keyValue.
              allFieldsTemporary.keyValue = undefined;

            }

          }

          //It will execute if keyValue not equal to undefined.
          if (allFieldsTemporary.keyValue != undefined) {

            temporaryJson[allFieldsTemporary.keyName] = allFieldsTemporary.keyValue;

            temporaryDisplayNames[allFieldsTemporary.keyName] = allFieldsTemporary.displayName;

          }

        }

      });

      totalObject.push(temporaryJson);

      displayNames.push(temporaryDisplayNames);

    });

    console.log(totalObject);

    console.log(displayNames);

    this.dialogref.close([this.allFields, totalObject, displayNames]);

  }

}